export default __webpack_public_path__ + "static/media/logo2.abc477d0.svg";